var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollabIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.03572 12.0702C9.36916 12.0702 12.0714 9.36787 12.0714 6.03444C12.0714 9.36708 14.7724 12.0689 18.1048 12.0702C14.7724 12.0714 12.0714 14.7732 12.0714 18.1059C12.0714 14.7724 9.36916 12.0702 6.03572 12.0702C2.70228 12.0702 -4.19231e-07 14.7724 -2.70074e-07 18.1059L0 24.1416L6.03572 24.1416C9.36916 24.1416 12.0714 21.4393 12.0714 18.1059C12.0714 21.4393 14.7737 24.1416 18.1072 24.1416L24.1429 24.1416L24.1429 18.1059C24.1429 14.7732 21.4419 12.0714 18.1095 12.0702C21.4419 12.0689 24.1429 9.36709 24.1429 6.03444L24.1429 -0.0012859L18.1072 -0.00128581C14.7737 -0.00128577 12.0714 2.701 12.0714 6.03444C12.0714 2.701 9.36916 -0.00128569 6.03572 -0.00128755L-2.4976e-08 -0.00128937L-2.82562e-07 6.03443C-4.24822e-07 9.36787 2.70228 12.0702 6.03572 12.0702Z",
    fill: "#009996"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollabIcon);
export default __webpack_public_path__ + "static/media/CollabIcon.3e02e1879955119e473ca369f4429dc9.svg";
export { ForwardRef as ReactComponent };